import type { SVGProps } from "react";
const SvgHsbcLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        d="M372.538 139.187H138.912L22.1 256l116.813 116.813h233.626L489.626 256z"
      />
      <path
        fill="#DB0011"
        d="M489.626 256 372.538 139.187v233.626zM255.725 256l116.813-116.813H138.912zM22.1 256l116.812 116.813V139.187zM255.725 256 138.912 372.813h233.626z"
      />
    </g>
  </svg>
);
export default SvgHsbcLogo;
